// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_ExportBucketsModal_list__qb7wH {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.storage_ExportBucketsModal_item__H2GPA {
  display: flex;
  align-items: center;
  gap: 8px;
}

.storage_ExportBucketsModal_label__jZo8y {
  color: var(--color-black);
  font-size: 14px;
}

.storage_ExportBucketsModal_controls__CFdRR > :first-child {
  flex: 1 1;
}

.storage_ExportBucketsModal_controls__CFdRR > :not(:first-child) {
  min-width: 65px;
  flex: 0 0 auto;
}

.storage_ExportBucketsModal_errorText__GMRP6 {
  margin-top: 12px;
  color: #d32f2f;
  color: var(--color-error, #d32f2f);
  font-size: 12px;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/modals/ExportBucketsModal/ExportBucketsModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAkC;EAAlC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.label {\n  color: var(--color-black);\n  font-size: 14px;\n}\n\n.controls > :first-child {\n  flex: 1;\n}\n\n.controls > :not(:first-child) {\n  min-width: 65px;\n  flex: 0 0 auto;\n}\n\n.errorText {\n  margin-top: 12px;\n  color: var(--color-error, #d32f2f);\n  font-size: 12px;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `storage_ExportBucketsModal_list__qb7wH`,
	"item": `storage_ExportBucketsModal_item__H2GPA`,
	"label": `storage_ExportBucketsModal_label__jZo8y`,
	"controls": `storage_ExportBucketsModal_controls__CFdRR`,
	"errorText": `storage_ExportBucketsModal_errorText__GMRP6`
};
export default ___CSS_LOADER_EXPORT___;
